import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function createHelixProjectReducer(state = initialState.createdEngagementHelixId, action) {
	switch (action.type) {
		case types.POST_HELIX_PROJECT: {
			return action.response ? action.response : state;
		}
		case types.CLEAR_HELIX_PROJECT: {
			return null;
		}
		case types.DELETE_HELIX_PROJECT: {
			return action.response ? action.response : state;
		}
		default:
			return state;
	}
}
